<template>
  <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding:15px;padding-bottom:2px !important"
        ><!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding:15px;padding-bottom:0px;"
          >
            <div style="padding-top:23px;font-weight:bolder;font-size:20px">
              مدیریت بخش های  فروشگاه
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 lg5 xl5 class="pa-5">
        <v-card>
          <v-card-title>بخش دوم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section2.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section2.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC2',Section2)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش پنجم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section5.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section5.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC5',Section5)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 lg3 xl3 class="pa-5">
        <v-card>
          <v-card-title>بخش سوم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section3.Text"  outlined dense label="عنوان 2"></v-text-field>
                <custom-picker v-for="(item,index) in Section3.TextColors" :key="index" :color="Section3.TextColors[index]" @Selected="Section3.TextColors[index] = $event"  outlined dense :label="'رنگ نوشته '+(index+1)"></custom-picker>
                <custom-picker :color="Section3.BgColor" @Selected="Section3.BgColor = $event"  outlined dense label="رنگ زمینه "></custom-picker>
                <f-up  @RetunedFileName="Section3.Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس 1"></f-up>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC3',Section3)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش ششم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section6.Link"  outlined dense label="لینک  "></v-text-field>
                <f-up  @RetunedFileName="Section6.Image = $event" Root="ELOGO" Folder="CONTENT" BtnTitle="عکس"></f-up>              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC6',Section6)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 lg4 xl4 class="pa-5">
        <v-card>
          <v-card-title>بخش چهارم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section4.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section4.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC4',Section4)"  outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <v-card class="mt-5">
          <v-card-title>بخش هفتم</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-text-field  v-model="Section7.Title"  outlined dense label="عنوان فارسی "></v-text-field>
                <v-text-field  v-model="Section7.EnTitle" style="direction:ltr"  outlined dense label="عنوان انگلیسی"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-btn @click="AddOption('SHOPSEC7',Section7)" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
     
    </v-layout>

    <template
      ><!--Loading Dialog-->
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
  </div>
</template>

<script>
const axios = require("axios");
const ApiUrl = require("../../../constant/apiurl");
const MSGHNDL = require("../../../constant/MessageHandler");
import { mapState, mapMutations, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { VueEditor } from "vue2-editor";
export default {
  name: "shopsections",
  components: {
    Loading,
    VueEditor
  },
  data: () => ({
    isLoading:false,
    Section2:{
      Title:"",
      EnTitle:""
    },
    Section3:{
      Text:"",
      Image:"",
      BgColor:"#ffffff",
      TextColors:["#ffffff","#ffffff"]
    },
    Section4:{
      Title:"",
      EnTitle:""
    },
    Section5:{
      Title:"",
      EnTitle:""
    },
    Section6:{
      Link:"",
      Image:""
    },
    Section7:{
      Title:"",
      EnTitle:""
    }
  }),
  async created() {
    let vm = this;
    axios.interceptors.request.use(
      config => {
        vm.isLoading = true;
        return config;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        vm.isLoading = false;
        return response;
      },
      error => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
     vm.loadCategories();
  },
  computed: {
    LANG() {
      return this.$store.getters.GetLang;
    }
  },
  watch: {
    LANG(nL, oL) {
      this.loadCategories();
    }
  },
  methods: {
    async AddOption(key,val)
    {
      var vm = this;
      var Model = {};
      Model.O_Key = key;
      Model.O_Value = JSON.stringify(val);
      await axios.post(ApiUrl.AddOption,Model)
      .then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
              MSGHNDL.OK(data.msg);
              await vm.loadCategories();
          }
          else
          {
              MSGHNDL.ERR(data.msg);
          }
      })
      .catch((error)=>{
          console.error(error);
          MSGHNDL.ERR(error);
      });
    },
    async loadCategories()
      {
          let vm = this;
          vm.isLoading  = true;
          await axios.post(ApiUrl.LoadOptions,{}).then(async (res)=>{
              let data = res.data;
              console.warn(data);
              if(data.status)
              {
                  if(data.data.length > 0)
                  {
                      data.data.forEach(item => {
                          if(item.o_Key == "SHOPSEC2")
                          {
                              vm.Section2 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SHOPSEC3")
                          {
                              vm.Section3 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SHOPSEC4")
                          {
                              vm.Section4 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SHOPSEC5")
                          {
                              vm.Section5 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SHOPSEC6")
                          {
                              vm.Section6 = JSON.parse(item.o_Value);
                          }
                          if(item.o_Key == "SHOPSEC7")
                          {
                              vm.Section7 = JSON.parse(item.o_Value);
                          }
                        
                      });
                  }
              }
              vm.isLoading = false
          }).catch((err)=>{
              console.error(err);
          });
      },

    SeoChanged(data) {
      this.seo = data;
    }
  }
};
</script>